<template>
    <button
        class="btn btn-md is-ghost btn-block"
        :class="[{ 'is-loading': loading }, buttonSizeClass]"
        @click="requestCustomerExcerpt"
    >
        <slot />
    </button>
</template>
<script>
    export default {
        props: {
            customer: {
                type: Object,
                required: true,
            },
            size: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            buttonSizeClass() {
                return this.size ? 'btn-' + this.size : null;
            },
        },

        methods: {
            requestCustomerExcerpt() {
                this.loading = true;
                axios.post(route('admin.gdpr.customer-excerpts.request', this.customer))
                    .then(() => {
                        flash_success('Registerutdrag finns snart att ladda ned på adressidan.');
                    })
                    .catch(() => {
                        flash_error('Det gick tyvärr inte att skapa ett registerutdrag för denna adress.');
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
